<!--
TODO write docs about it
The initial version was made in https://codesandbox.io/s/droddown-for-aggrid-gketp
Available props
1. label: String (the text to display if no option is selected), default: 'Select'
2. options: Array, String (options to select)
     NOTE: if options is string, will target a getter from the store that returns those options
3. optionValue (property of option which holds the 'value'), default: id
4. optionLabel (property of option which holds the 'label'), default: label
5. selected (if there is a preselected value)
6. getValueFromParent (if the selected value is not what we want we can pass that function which receives
                       the selected value and should return the transformed selected value)
7. multiselect (if multiple options can be selected)
8. returnObject (when is multiselect use this prop to return selected objects)
-->

<template>
  <div ref="dropdown" class="dropdown" tabindex="0">
    <div class="activator" @click="isOpen = !isOpen">
      <span class="displayed-text">{{ textToDisplay }}</span>
      <span class="icon">&triangledown;</span>
    </div>

    <div :class="{ open: isOpen }" class="content">
      <div v-for="(option, index) of options" :key="areOptionsObjects ? option[optionValue] : index" class="item">
        <div class="item-group-checked" @click="selectedValueChanged(option)">
          <q-checkbox v-if="multiselect" v-model="selected" :val="option[optionValue]" />
          <p class="text-group-checked">
            {{ areOptionsObjects ? option[optionLabel] : option }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import store from '@/store'

export default Vue.extend({
  store,

  data: () => ({
    isOpen: false,
    selected: null
  }),

  computed: {
    label() {
      return this.params.label || 'Select'
    },

    options() {
      if (typeof this.params.options === 'string') return store.getters[this.params.options]
      return this.params.options
    },

    areOptionsObjects() {
      const option = this.options[0]
      return typeof option === 'object'
    },

    optionValue() {
      return this.params.optionValue || 'id'
    },

    optionLabel() {
      return this.params.optionLabel || 'label'
    },

    getValueFromParent() {
      return this.params.getValueFromParent
    },

    multiselect() {
      return this.params.multiselect
    },

    returnObject() {
      return this.params.returnObject
    },

    textToDisplay() {
      if (!this.selected || (this.multiselect && !this.selected.length)) return this.label
      if (this.multiselect) {
        const text = this.selected.reduce((acc, curr) => {
          const option = this.options.find(o => o[this.optionValue] === curr)
          acc += option[this.optionLabel] + ', '
          return acc
        }, '')
        return text.slice(0, -2)
      } else if (!this.areOptionsObjects) return this.selected
      return this.selected[this.optionLabel]
    }
  },

  created() {
    if (this.params.selected) this.selected = this.params.selected
  },

  mounted() {
    this.$nextTick(() => {
      this.$refs.dropdown.focus()
      this.isOpen = true
    })
  },

  methods: {
    selectedValueChanged(option) {
      if (this.multiselect) {
        if (this.selected.includes(option[this.optionValue])) {
          this.selected = this.selected.filter(s => s !== option[this.optionValue])
        } else this.selected.push(option[this.optionValue])
      } else {
        this.selected = option
        this.isOpen = false
      }
    },

    isPopup() {
      return true
    },

    getValue() {
      if (this.getValueFromParent) return this.getValueFromParent(this.selected)
      if (this.multiselect) {
        if (this.returnObject) {
          return this.selected.reduce((acc, curr) => {
            const option = this.options.find(o => o[this.optionValue] === curr)
            if (option) acc.push(option)
            return acc
          }, [])
        }
        return this.selected
      }
      if (this.areOptionsObjects) return this.selected[this.optionValue]
      return this.selected
    }
  }
})
</script>

<style scoped>
.dropdown {
  width: 200px;
  position: relative;
  user-select: none;
  background: white;
}
.activator {
  border: 1px solid #dba9c9;
  display: flex;
  justify-content: space-between;
  padding: 6px 10px;
  cursor: pointer;
  position: relative;
  line-height: 22px;
}
.activator .icon {
  font-size: 22px;
}
.displayed-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.content {
  max-height: 300px;
  display: none;
  position: absolute;
  width: 100%;
  top: 110%;
  border: 1px solid;
  overflow: auto;
  background: azure;
}
.content.open {
  display: grid;
}
.item {
  user-select: none;
}
.item:hover {
  background: #e4e4e4;
}
.item-group-checked {
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  border-bottom: 1px solid #cbb2b2;
  cursor: pointer;
}
.text-group-checked {
  margin: 0;
  padding: 10px;
  transition: background 1s;
  border-left: 1px solid #d1e2ff;
}
</style>
